import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useFavorites } from '@/arche/arches/favorites/hooks/useFavorites';

/** Sentinel values, kept in sync with the backend arche filter. */
export const ARCHE_FILTER_ALL = '__all__';
export const ARCHE_FILTER_SYSTEM = 'system';

interface ArcheFilterSelectProps {
  /** '' = all (rendered as ALL sentinel), 'system', or a specific arche id. */
  value: string;
  onChange: (value: string) => void;
}

/**
 * Filter support submissions by the arche they're tagged with. Options are the
 * admin's worktop arches (the same set users tag from) plus "All" and "Fias
 * system". The backend accepts any arche id, so a value can also arrive via a
 * deep link even if it isn't favorited.
 */
export function ArcheFilterSelect({ value, onChange }: ArcheFilterSelectProps) {
  const { favorites } = useFavorites();

  return (
    <Select
      value={value || ARCHE_FILTER_ALL}
      onValueChange={(v) => onChange(v === ARCHE_FILTER_ALL ? '' : v)}
    >
      <SelectTrigger className="w-full sm:w-[200px]">
        <SelectValue placeholder="Arche" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={ARCHE_FILTER_ALL}>All arches</SelectItem>
        <SelectItem value={ARCHE_FILTER_SYSTEM}>Fias system</SelectItem>
        {favorites.map((f) => (
          <SelectItem key={f.archId} value={f.archId}>
            {f.archeName}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
